import React from 'react';
import DesktopOnly from '../../Containers/DesktopOnly/DesktopOnly.mjs';
import Heading from '../../Typography/Heading/Heading.mjs';
import { StyledHeroContainer, StyledImageContainer, StyledImageUnderlayContainer, StyledThumbnailContainer, StyledThumbnailInnerContainer, StyledInfo } from './Hero.styles.mjs';
import Image from 'next/image';
import { useTheme } from 'styled-components';

const Hero = ({ title, thumbnail, href, action, onClick }) => {
    const theme = useTheme();
    const handleHeroStoryClick = () => onClick && onClick({ title, href });
    return (React.createElement(StyledHeroContainer, { className: "minute-hero", href: href, onClick: handleHeroStoryClick },
        React.createElement(StyledImageContainer, null,
            React.createElement(StyledImageUnderlayContainer, { className: "minute-hero-underlay" },
                React.createElement(Image, { fill: true, objectFit: "cover", alt: thumbnail.alt, className: "minute-hero-underlay-image", src: thumbnail.src })),
            React.createElement(StyledThumbnailContainer, { className: "minute-hero-thumbnail" },
                React.createElement(StyledThumbnailInnerContainer, null,
                    React.createElement(Image, { fill: true, objectFit: "cover", className: "minute-hero-thumbnail-image", src: thumbnail.src, alt: thumbnail.alt, unoptimized: true })))),
        React.createElement(StyledInfo, null,
            React.createElement(Heading, { tag: "h1" }, title),
            React.createElement(DesktopOnly, { breakpoint: theme.breakpoints.sm }, action))));
};

export { Hero as default };
//# sourceMappingURL=Hero.mjs.map
